import styled from 'styled-components';

const GroupRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;

export default GroupRow;
